<template>
	<div class="deliver">
		<div class="deliver-top" v-if="showTip">
				<img class="icon-warning" src="../../assets/img/order/icon-waring.png"></img>
				<div class="tips-content">
					<p>批量发货目前仅支持快递订单，暂不支持同城配送和到店体验的订单。请按模板要求填写发货信息</p>
					<p>为保障导入数据的准确性，单次批量发货请勿超出1000条记录，如超出请拆分文件后分别上传</p>
				</div>
				<!-- <div class="tips-close" @click="hideTip()">
					x
				</div> -->
		</div>
		<div class="deliver-main" style="background: #fff;">
			<div style="display: flex;">
				<el-upload
				 style="margin: 0 10px 20px 17px;"
				  :headers="upload.headers" :action="upload.url"
				  :on-success="getfile" :multiple="false"
				  :show-file-list="false"
				  :before-upload="beforeUpload">
					<el-button type="primary">批量导入</el-button>
				</el-upload>
				<el-button type="primary"
					style="width: 102px;height: 40px;border-radius: 4px;background-color: #ffffff;border: 1px solid #DCDFE6;color: #606266;padding: 0;" @click="downMuban()">下载发货模板</el-button>
			</div>
			
			<div  style="margin:0 10px;">
				<el-tabs v-model="activeName" type="card" @tab-click="handleClick($event)">
					<el-tab-pane label="全部" name="all"></el-tab-pane>
					<el-tab-pane :label='"导入成功("+success_count+")"' name="1"></el-tab-pane>
					<el-tab-pane :label='"导入失败("+fail_count+")"' name="2"></el-tab-pane>
				</el-tabs>
				<el-table style="width: 100%" :data="tableData" :cell-style="tableCellStyle">
					<el-table-column prop="import_time" label="导入时间" width="180" align="center">
					</el-table-column>
					<el-table-column prop="order_sn" label="订单编号" width="220" align="center">
					</el-table-column>
					<el-table-column prop="ems_name" label="快递公司" align="center">
					</el-table-column>
					<el-table-column prop="ems_code" label="快递单号" align="center">
					</el-table-column>
					<el-table-column prop="import_status" label="导入状态" align="center">
					</el-table-column>
					<el-table-column width="220" class="short_errmsg" show-overflow-tooltip prop="short_errmsg" label="失败原因" align="center">
						<!-- <template slot-scope="scope">
							<div style="color: #F56C6C;font-size: 14px;">{{scope.row.short_errmsg}}</div> -->
							<!-- <el-tooltip placement="top" :open-delay="500" effect="dark">
								<div slot="content" style="font-size: 14px;color: #F56C6C;">{{scope.row.short_errmsg}}</div>
								<div style="font-size: 14px;font-family: PingFang-SC-Medium, PingFang-SC;font-weight: 500;color: #333333;text-overflow: ellipsis;
  white-space: nowrap; overflow: hidden;word-break: break-all;">{{scope.row.short_errmsg}}</div>
							</el-tooltip> -->
						<!-- </template> -->
					</el-table-column>
				</el-table>
				<div style="text-align: center;margin-top: 75px;padding-bottom: 35px;" v-if="tableData.length==0">
					<img src="../../assets/img/order/nodeliver.png" style="width: 126px;height: 140px;" />
					<p class="nohhr" v-if="activeName=='all'">您还没有批量处理过哦～</p>
					<p class="nohhr" v-if="activeName=='1'">您还没有导入成功记录哦～</p>
					<p class="nohhr" v-if="activeName=='2'">您还没有导入失败记录哦～</p>
				</div>
			</div>
			
		</div>
	</div>
</template>

<script>
	import {downloadMuban,downloadResult,getShippingOrder,uploadExcel} from '../../api/order';
	import {
		handleCode
	} from '@/utils/request';
	import { baseURL, noPermissionCode} from '@/config';
	export default {
		data() {
		    return {
				upload: {
					// 设置上传的请求头部
					headers: {
						authorization: this.$store.getters['user/accessToken'] ? this.$store.getters['user/accessToken'] : ''
					},
					// 上传的地址
					url: baseURL + '/api/brand.Order/importShippingExcel'
				},
				showTip:true,
				all_count:0,
				success_count:0,
				fail_count:0,
				tableData: [],
				list:[],
				success:[],
				fail:[],
				activeName: 'all',
			}
		},
		mounted(){
			
		},
		methods: {
			tableCellStyle({row,column,rowIndex,columnIndex}){
				if(columnIndex==5){
					return 'color: #F56C6C;font-size: 14px;';
				}
			},
			getInfo(){
				getShippingOrder({}).then(res => {
					this.list = res.data.list;
					this.tableData = this.list;
					this.all_count = res.data.all_count;
					this.success = res.data.success;
					this.success_count = res.data.success_count;
					this.fail = res.data.fail;
					this.fail_count = res.data.fail_count;
				})
			},
			getfile(res, file){
				var that = this;
				if(res.code==0){
					this.$message.success(res.message);
				}else{
					this.$message.error(res.message);
					setTimeout(function () {
						that.downResult();
					}, 1000);
				}
				setTimeout(function () {
					that.getInfo();
				}, 2000);
			},
			//上传前回调
			beforeUpload(file) {
				if (['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'].indexOf(file.type) === -1) {
					this.$message.error("文件格式仅支持：xls，xlsx");
					return false;
				}
			},
			downResult(){
				downloadResult({}).then(res => {
					const content = res
					const blob = new Blob([content]);
					
					const fileName = this.$store.getters['user/brandInfo'].simple_name+"发货单导入结果.xlsx";
					if ("download" in document.createElement("a")) {
						// 非IE下载
						const _link = document.createElement("a");
						_link.download = fileName;
						_link.style.display = "none";
						_link.href = URL.createObjectURL(blob);
						document.body.appendChild(_link);
						_link.click();
						URL.revokeObjectURL(_link.href); // 释放URL 对象
						document.body.removeChild(_link);
					} else {
						// IE10+下载
						navigator.msSaveBlob(blob, fileName);
					}
				})
			},
			downMuban(){
				
				downloadMuban({}).then(res => {
					  const content = res
					  const blob = new Blob([content]);
					  
					  const fileName = this.$store.getters['user/brandInfo'].simple_name+"发货单导入模板.xlsx";
					  if ("download" in document.createElement("a")) {
						// 非IE下载
						const _link = document.createElement("a");
						_link.download = fileName;
						_link.style.display = "none";
						_link.href = URL.createObjectURL(blob);
						document.body.appendChild(_link);
						_link.click();
						URL.revokeObjectURL(_link.href); // 释放URL 对象
						document.body.removeChild(_link);
					  } else {
						// IE10+下载
						navigator.msSaveBlob(blob, fileName);
					  }
				})
			},
			handleClick(e){
				if(e.name=='all'){
					this.tableData = this.list;
				}else if(e.name=='1'){
					this.tableData = this.success;
				}else if(e.name=='2'){
					this.tableData = this.fail;
				}
			},
			hideTip(){
				this.showTip = false;
			}
		}
	}
</script>

<style scoped>
	.deliver-top{
		margin-bottom: 15px;
		display: flex;
		height: 60px;
		align-items: center;
		background: #FDF6ED;
		border-radius: 4px;
	}
	.deliver-top .icon-warning{
		width: 28px;
		height: 28px;
		margin: 0 9px 0 4px;
	}
	.deliver-top .tips-content{
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #E6A23C;
		line-height: 20px;
	}
	.deliver-top .tips-close{
		margin-right: 11px;
		margin-left: auto;
		width: 34px;
		height: 34px;
		line-height: 34px;
		text-align: center;
		color: RGBA(189, 194, 202, 1);
		font-size: 16px;
	}
	.deliver-main{
		padding-top: 16px;
		padding-bottom: 16px;
		min-height: 544px;
	}
	.deliver-main .el-table__empty-block{
		display: none;
	}
	.deliver-main .nohhr {
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #999999;
	}
	.el-tooltip__popper{
	    max-width:20%;
	}
	.el-tooltip__popper,.el-tooltip__popper.is-dark{
		 background:rgb(48, 65, 86) !important;
		 color: #fff !important;
		 line-height: 24px;
	 }
</style>
